// ADMIN
export const ADMIN_LOGOUT = "ADMIN_LOGOUT"

export const ADMIN_LOGIN_REQUESTING = "ADMIN_LOGIN_REQUESTING"
export const ADMIN_LOGIN_SUCCESS = "ADMIN_LOGIN_SUCCESS"
export const ADMIN_LOGIN_ERROR = "ADMIN_LOGIN_ERROR"
